import React from 'react';
import { CheckIcon, GlobeIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../components/CtaButton';
import { CountdownTimer } from '../components/CountdownTimer';
import { ScarcityBar } from '../components/ScarcityBar';
import { valueRows } from '../data/content';
const dealPoints = ['One-time payment', 'Lifetime digital access', 'Instant download', '7-day guarantee'];
export function Offer() {
  return <section id="offer" className="w-full bg-navy-950 py-14 sm:py-20" aria-labelledby="offer-heading" data-id="element-234" data-mp="39c1lxwy3yrf6">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-235" data-mp="34gw00y4phcr3">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-300" data-id="element-236" data-mp="3idhwc4oxatje">
          The complete value of the system
        </p>
        <h2 id="offer-heading" className="mx-auto mt-3 max-w-xl text-center font-display text-[26px] font-black leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-237" data-mp="1o0jnzqmsa6yp">
          $414 of clinical resources. Today, $27.
        </h2>

        <ul className="mt-9 space-y-3" data-id="element-238" data-mp="x5dra45je56z">
          {valueRows.map(row => <li key={row.title} className="rounded-xl border border-white/10 bg-white/[0.05] p-4 sm:p-5" data-id="element-239" data-mp="123ytg94cmyy2">
              <div className="flex items-start justify-between gap-3" data-id="element-240" data-mp="1705pna6y0w2t">
                <h3 className="font-display text-[15px] font-extrabold uppercase tracking-[0.06em] text-white sm:text-[17px]" data-id="element-241" data-mp="1bu9v1p0k8w1s">
                  {row.title}
                </h3>
                <span className="shrink-0 rounded-md bg-white/10 px-2 py-1 text-[12px] font-bold text-brand-100" data-id="element-242" data-mp="1ksdkgweo2cyv">
                  {row.value}
                </span>
              </div>
              <p className="mt-2 text-[13.5px] leading-snug text-brand-100" data-id="element-243" data-mp="1urunf62jacr5">
                {row.description}
              </p>
            </li>)}
        </ul>

        <div className="mt-5 flex items-center justify-between rounded-xl border border-white/15 bg-white/10 px-4 py-3.5" data-id="element-244" data-mp="djykxlxvild">
          <span className="font-display text-[14px] font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-245" data-mp="3ohqbe7eunozg">
            Total value
          </span>
          <span className="font-display text-2xl font-black text-white line-through decoration-red-400 decoration-[3px]" data-id="element-246" data-mp="3jkzuxiz4urdi">
            $414
          </span>
        </div>

        <div className="mt-8 rounded-2xl bg-white p-5 text-center shadow-card sm:p-8" data-id="element-247" data-mp="3tgbfihx82st6">
          <p className="text-[11.5px] font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-248" data-mp="baybgk48gzax">
            Today you can get the complete system for
          </p>
          <p className="mt-2 font-display text-[64px] font-black leading-none tracking-tight text-navy-900 sm:text-[80px]" data-id="element-249" data-mp="6asohh8ws0z6">
            $27
          </p>

          <ul className="mx-auto mt-5 grid max-w-sm grid-cols-2 gap-2" data-id="element-250" data-mp="g3ren3k1zzkw">
            {dealPoints.map(point => <li key={point} className="flex items-center gap-1.5 text-left" data-id="element-251" data-mp="u2hegqy9cdcy">
                <CheckIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-emerald-600" data-id="element-252" data-mp="q1xg5k1y73p8" />
                <span className="text-[12.5px] font-semibold leading-snug text-navy-900" data-id="element-253" data-mp="18pziro7wr5yu">
                  {point}
                </span>
              </li>)}
          </ul>

          <div className="mx-auto mt-7 max-w-md" data-id="element-254" data-mp="zp1dl2lqgseo">
            <CtaButton label="Yes — I want the Master System" sub="Get instant access for $27" size="lg" data-id="element-255" data-mp="zqcij5qx067d" />
          </div>

          <div className="mt-5" data-id="element-256" data-mp="pwvr28e9336v">
            <CountdownTimer data-id="element-257" data-mp="up5ar6orv70p" />
          </div>

          <div className="mt-6" data-id="element-258" data-mp="uq6wc53ezbwo">
            <ScarcityBar spotsLeft={9} data-id="element-259" data-mp="ur8a4hbteci3" />
          </div>

          <p className="mx-auto mt-6 flex max-w-sm items-start gap-2 rounded-xl bg-brand-50 p-3.5 text-left" data-id="element-260" data-mp="gys375fslubw">
            <GlobeIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-600" data-id="element-261" data-mp="l059fgmsrzjc" />
            <span className="text-[12.5px] leading-snug text-navy-900" data-id="element-262" data-mp="70m5l010racu">
              <strong className="font-bold" data-id="element-263" data-mp="bz74mw4jbnzp">Automatic currency conversion.</strong> The price
              is shown and charged in your local currency at checkout — wherever you practice.
            </span>
          </p>

          <p className="mt-4 flex items-center justify-center gap-1.5 text-[12px] font-semibold text-ink-500" data-id="element-264" data-mp="1abjeisjd105f">
            <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-emerald-600" data-id="element-265" data-mp="15igsr6ktquzs" />
            Secure checkout · 7-day money-back guarantee
          </p>
        </div>
      </div>
    </section>;
}